import FingerprintJS from "@fingerprintjs/fingerprintjs"
import { RoleId } from "./constants"

const toastBaseOptions = {
    position: "top",
    isClosable: true,
}

export function toastError(title, description = "") {
    return {
        title: title,
        description: description,
        status: "error",
        ...toastBaseOptions
    }
}

export function toastSuccess(title) {
    return {
        title: title,
        status: "success",
        ...toastBaseOptions
    }
}

export function toastWarning(title) {
    return {
        title: title,
        status: "warning",
        ...toastBaseOptions
    }
}

/**
 * Заменяет все null в объекте на пустую строку ''
 * @param {object} obj - любой объект
 * @returns новый объект без null
 */
export function objReplaceNulls(obj) {
    if (typeof obj !== 'object')
        return null
    let result = {...obj}
    for(var key in result)
        if (result[key] === null)
            result[key] = ''
    return result
}

/**
 * Заменяет все пустые строки в объекте на null
 * @param {object} obj - любой объект
 * @returns новый объект без пустых строк
 */
export function objEmptyStringsToNull(obj) {
    if (typeof obj !== 'object')
        return null
    let result = {...obj}
    for(var key in result)
        if (result[key] === '')
            result[key] = null
    return result
}

export async function getFingerprint() {
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const result = await fp.get()
    return result.visitorId
}

export function isValidUrl(str) {
    try {
        return !!new URL(str)
      }
      catch (_) {
        return false
      }
}

export function generateRandomString(length = 32) {
    const possibleCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * possibleCharacters.length);
        result += possibleCharacters[randomIndex];
    }
    return result;
}

export function generateCodeVerifier(length = 128) {
    return generateRandomString(length);
}

export function generateState(length = 32) {
    return generateRandomString(length);
}

export function generateNonce(length = 32) {
    return generateRandomString(length);
}

// Функция для создания code_challenge на основе code_verifier с использованием SHA-256
export async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(digest);
}

// Функция для преобразования бинарных данных в base64url-формат
export function base64UrlEncode(buffer) {
    const base64String = btoa(String.fromCharCode(...new Uint8Array(buffer)));
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function userHasPageAccess(user, pageRoleIds) {
    if (!user?.active_context)
        return false
    return [RoleId.ADMIN, ...pageRoleIds].includes(user?.active_context.role.id)
}

export function userHasRole(user, roleIdentifier) {
    if (user?.roles?.length > 0)
        for (let r of user.roles)
            if (r.identifier === roleIdentifier)
                return true
    return false
}

export function toISODate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
